import script from "./Enter2faCodeView.vue?vue&type=script&setup=true&lang=js"
export * from "./Enter2faCodeView.vue?vue&type=script&setup=true&lang=js"

import "./Enter2faCodeView.vue?vue&type=style&index=0&id=b480f720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b480f720"]])

export default __exports__